/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  totalBurnedPerDayListTotalBurnedPerDayApiV1LedgersLedgerCanisterIdTotalBurnedPerDayGet,
} from "../../funcs/totalBurnedPerDayListTotalBurnedPerDayApiV1LedgersLedgerCanisterIdTotalBurnedPerDayGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .ListTotalBurnedPerDayApiV1LedgersLedgerCanisterIdTotalBurnedPerDayGetRequest$inboundSchema,
};

export const tool$totalBurnedPerDayListTotalBurnedPerDayApiV1LedgersLedgerCanisterIdTotalBurnedPerDayGet:
  ToolDefinition<typeof args> = {
    name:
      "total-burned-per-day-v1",
    description: `List Total Burned Per Day

Original tool name: api-v1-ledgers-ledger-canister-id-total-burned-per-day-get`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await totalBurnedPerDayListTotalBurnedPerDayApiV1LedgersLedgerCanisterIdTotalBurnedPerDayGet(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };